import { useTheme } from 'styled-components';
import { AppTheme } from '@/themes/types';

export function useThemeAsset() {
  const theme = useTheme() as AppTheme;

  return {
    logo: theme.assets.logo,
    logoNavbar: theme.assets.logoNavbar,
    grayscaleLogo: theme.options.grayscaleLogo ?? false,
    get: (key: keyof AppTheme['assets']) => theme.assets[key],
    icon: (filename: string) => `${theme.assets.iconBasePath}${filename}`,
    iconCategories: theme.options.iconCategories,
    typeIcons: theme.options.typeIcons
  };
}
